import type { ReactNode } from 'react'
import type { ShellSlotMap } from '../../layout'
import './PlayViewer.css'

interface VanillaCanvasFrameProps {
  /** Template-specific layer(s) that fill the viewport behind the chrome. */
  canvas: ReactNode
  /** Additional shell class for template-specific canvas behavior. */
  className?: string
  slots: ShellSlotMap
}

/**
 * Shared structural frame for both Vanilla templates.
 *
 * The templates differ only in what fills `canvas`: Le Vanilla supplies the
 * active camera, while Le Vanilla + Map supplies its persistent map/camera
 * layers and mode controls. Viewer chrome and responsive panel behavior stay
 * identical by construction.
 *
 * The frame is also the fullscreen root: element fullscreen must carry the
 * view dock and floating panels with it, or a fullscreen viewer loses all
 * map/camera navigation.
 */
export function VanillaCanvasFrame({ canvas, className = '', slots }: VanillaCanvasFrameProps) {
  return (
    <div
      className={`play-theme play-viewer lv-shell lv-canvas-shell${className ? ` ${className}` : ''}`}
      data-fullscreen-root
    >
      <div className="lv-canvas-layer">{canvas}</div>

      {slots.topbar && <div className="lv-canvas-topbar">{slots.topbar}</div>}

      <main className="lv-canvas-panels">
        <section className="lv-canvas-event-panel" aria-label="Event details">
          <div className="lv-meta">{slots.below_player}</div>
        </section>

        <aside className="lv-rail-wrap lv-canvas-camera-panel">{slots.sidebar}</aside>
      </main>

      {slots.mobile_switcher}
    </div>
  )
}
